<template>
  <v-tabs-items v-model="floor" vertical v-if="externalEventId">
    <exhibition-floor
      :booths="externalFloor.booths"
      v-for="externalFloor in externalFloors"
      :key="externalFloor.id"
    >
      <template v-slot:image>
        <v-img
          class="elevation-6"
          :src="externalFloor.imageUrl"
          :alt="externalFloor.name"
        />
      </template>
    </exhibition-floor>
  </v-tabs-items>
  <v-tabs-items v-model="floor" vertical v-else-if="pageType !== 'ICSMGE'">
    <exhibition-floor :booths="boothListEg">
      <template v-slot:image>
        <v-img
          class="elevation-6"
          src="~@/assets/EG_ISRM_2023.png"
          alt="Austellungsplan EG"
          v-if="pageType === 'ISRM'"
        />
        <v-img
          class="elevation-6"
          src="~@/assets/EG.png"
          alt="Austellungsplan EG"
          v-else
        />
      </template>
    </exhibition-floor>

    <exhibition-floor :booths="boothListOg1">
      <template v-slot:image>
        <v-img
          class="elevation-6"
          src="~@/assets/1_OG.png"
          alt="Austellungsplan 1OG"
        />
      </template>
    </exhibition-floor>

    <exhibition-floor :booths="boothListOg2">
      <template v-slot:image>
        <v-img
          class="elevation-6"
          src="~@/assets/2_OG_ISRM_2023.png"
          alt="Austellungsplan 2OG"
          v-if="pageType === 'ISRM'"
        />
        <v-img
          class="elevation-6"
          src="~@/assets/2_OG.png"
          alt="Austellungsplan 2OG"
          v-else
        />
      </template>
    </exhibition-floor>
  </v-tabs-items>
  <v-tabs-items v-model="floor" vertical v-else>
    <exhibition-floor :booths="booths">
      <template v-slot:image>
        <!-- using img tag here to show svg correctly in firefox -->
        <img
          src="~@/assets/ICSMGE.svg"
          alt="Austellungsplan ICSMGE"
          style="width: 100%;max-height: 100%;"
        />
      </template>
    </exhibition-floor>
  </v-tabs-items>
</template>

<script>
import { mapGetters } from "vuex";
import ExhibitionFloor from "./ExhibitionFloor/ExhibitionFloorMap";

export default {
  props: ["floor"],
  components: {
    ExhibitionFloor,
  },
  computed: {
    ...mapGetters([
      "boothListEg",
      "boothListOg1",
      "boothListOg2",
      "booths",
      "pageType",
      "externalEventId",
      "externalFloors",
    ]),
  },
};
</script>
